import { VALUATION_TABS } from '../../constants/realtyValuation';
import { EValuationTabs, IRealtyValuation } from '../../types/realtyValuation';

export function getValuationTabs({ salesDynamics }: IRealtyValuation) {
  if (!salesDynamics || !salesDynamics.chart) {
    return VALUATION_TABS.filter(tab => tab.id !== EValuationTabs.SellStatus);
  }

  return VALUATION_TABS;
}
